import React, { useState, useEffect } from "react";

// import "babel-polyfill";
import { Link } from "@reach/router";
import useGame from "../../hooks/useGame";
import { navigate } from "@reach/router";
import styled from "styled-components";
import {
  TopicsContainer,
  LevelListContainer,
  GameSelectionContainer
} from "../../styled_components/containers";
import {
  Button,
  GreenButton,
  GreyedButton
} from "../../../../globals/components/button";
import Checkbox from "../../../../globals/components/Checkbox";
import { Loading } from "../../../../globals/components/loading";
import useTopics from "../../hooks/useTopics";
import MultiplyDivide from "../../applications/MultiplyDivide/Practice.js";
import Spelling from "../../applications/Spelling/Practice.js";
import Addition from "../../applications/Addition/Practice.js";
import Fractions from "../../applications/Fractions/Practice.js";
import Grammar from "../../applications/Grammar/Practice.js";
import Geometry from "../../applications/Geometry/Practice.js";
import Measurements from "../../applications/Measurements/Practice.js";
import PlaceValue from "../../applications/NumPlace/Practice.js";
import Statistics from "../../applications/Statistics/Practice.js";
import Numerals from "../../applications/Numerals/Practice.js";
import Algebra from "../../applications/Algebra/Practice.js";
import Phonics from "../../applications/Phonics/Practice.js";
import Numbersense from "../../applications/NumberSense/Practice.js";
import Ratios from "../../applications/Ratios/Practice.js";
import MathsVocab from "../../applications/MathsVocab/Practice.js";

import RatingStats from "../../hooks/useRatingStats";
import ReactTooltip from 'react-tooltip';
import { debug } from "util";
import { Scale } from 'react-scaling';

import Papa from "papaparse";
import additionsExtraQuestions from '../../assets/Addition/ExtraQuestions/additions_extraquestions.csv';
import numplaceExtraQuestions from '../../assets/NumberAndPlace/ExtraQuestions/numplace_extraquestions.csv';
import multiplicationExtraQuestions from '../../assets/Multiplication/ExtraQuestions/mult_extraquestions.csv';
import fractionsExtraQuestions from '../../assets/Fractions/ExtraQuestions/fractions_extraquestions.csv';
import measurementsExtraQuestions from '../../assets/Measurements/ExtraQuestions/measurement_extraquestions.csv';
import geometryExtraQuestions from '../../assets/Geometry/ExtraQuestions/geometry_extraquestions.csv';

export default function Practice({ id, ...props }) {
  const game = useGame(id);
  const { topics } = useTopics({ game_type: game.game_type }, game);
  const [selectedLevel, setSelectedLevel] = useState([]);
  const [selectedLevelID, setSelectedLevelID] = useState();
  const [gameStatus, setGameStatus] = useState(props.startImmediately || false);
  const [selectedTopics, setSelectedTopics] = useState(props.topics || []);
  const [selectedTopicsKeys, setSelectedTopicKeys] = useState(props.topicKeys || []);
  const [selectAll, setSelectAll] = useState(false);
  const [timeLimit, setTimeLimit] = useState(-1);
  const [questionLimit, setQuestionLimit] = useState(-1);

  var ratings = RatingStats();
  const [myRating, setMyRating] = useState();

  const [addedExtraAdditions, setAddedExtraAdditions] = useState(false);


  useEffect(() => {
    if (ratings !== undefined) {
      setMyRating(GetRating(id));
    }
  }, [ratings]);

  function GetRating(id) {
    var myrate = -1;
    for (let i = 0; i < ratings.length; i++) {
      if (ratings[i].service_id == id) {
        myrate = ratings[i].rating;
        //convert myrate to level number between 1-10

        myrate = Math.round(myrate / 150);

        if (myrate > 10)
          myrate = 10;
      }
    }
    console.log(myrate);
    return myrate;
  }

  const levels = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  if (props.timelimit > 0 && props.minimum == null && timeLimit < 0) {
    setTimeLimit(props.timelimit);
    setQuestionLimit(-1);
    console.log("time limit mode");
  }

  if (props.minimum > 0 && questionLimit < 0) {
    setTimeLimit(-1);
    setQuestionLimit(props.minimum);
    console.log("minimum questions mode")
  }

  function HasTopicAlready(tquestion, questionslist) {
    for (let i = 0; i < questionslist.length; i++) {
      const element = questionslist[i];
      if (element.topic_key == tquestion.topic_key) {
        return true;
      }
    }
    return false;
  }

  function AddExtraTopics() {

    console.log("adding extra topics")
    console.log(game.service_key);

    let extraQs;
    if (game.service_key == "addition") {
      extraQs = additionsExtraQuestions;
    } else if (game.service_key == "numplace") {
      extraQs = numplaceExtraQuestions;
    }
    else if (game.service_key == "timetables") {
      extraQs = multiplicationExtraQuestions;
    }
    else if (game.service_key == "fractions") {
      extraQs = fractionsExtraQuestions;
    } else if (game.service_key == "measurement") {
      extraQs = measurementsExtraQuestions;
    }
    else if (game.service_key == "geometry") {
      extraQs = geometryExtraQuestions;
    }
    if (extraQs == null || extraQs == undefined) {
      return;
    }
    //import from CSV
    Papa.parse(extraQs, {
      download: true,
      header: true,
      complete: function (results) {
        console.log("Extra Questions:");
        console.log(results.data)
        let addMe = [];
        for (let x = 0; x < results.data.length; x++) {
          const extraQ = results.data[x];
          if (HasTopicAlready(extraQ, addMe) == false && extraQ.topic_key != undefined) {
            let ntopic = {
              difficulty: extraQ.difficulty,
              topic_key: extraQ.topic_key,
              id: extraQ.topic_key,
              name: extraQ.topic,
              topicname: extraQ.topic
            };
            addMe.push(ntopic);
          }
        }
        console.log("ALLTOPICS:");
        console.log(addMe);
        for (let i = 0; i < addMe.length; i++) {
          topics[parseInt(addMe[i].difficulty)].push(addMe[i]);
        }
        setAddedExtraAdditions(true);
        console.log("done adding extra questions");
      },
    });


  }

  function onLevelSelect(id) {

    if (addedExtraAdditions == false) {
      AddExtraTopics();
    }

    const topicsSelected = topics[id];

    console.log(topicsSelected);
    if (topicsSelected == undefined) {
      onLevelSelect(1);
    } else {
      //sort alphabetically
      topicsSelected.sort((a, b) => a.topicname.toLowerCase().localeCompare(b.topicname.toLowerCase(), 'en', { numeric: true }))
      setSelectedLevelID(id);
      setSelectedLevel(topicsSelected);
      console.log(topics);
      console.log(topicsSelected);
      console.log(id);
    }
  }

  //function setEmpty


  function onTopicsSelect(id) {
  // Only add if the current count is less than 5
  if (selectedTopics.length < 5) {
    setSelectedTopics([...selectedTopics, id]);
    if (isNaN(id)) {
      setSelectedTopicKeys([...selectedTopicsKeys, id]);
    }
  } else {
    alert("You can only select up to 5 topics.");
  }
}

  function onTopicsUnselect(id) {
    setSelectedTopics(
      selectedTopics.filter(function (value) {
        return value !== id;
      })
    );
    setSelectedTopicKeys(
      selectedTopicsKeys.filter(function (value) {
        return value !== id;
      })
    );
    setSelectAll(false);
  }

  function launchGame() {
    setGameStatus(true);
  }

  function endGame() {
    console.log("endgame");
    setGameStatus(false);
    props.onEnd && props.onEnd();
  }

  useEffect(() => {
    if (selectAll) {
      let topicIds = [];
      selectedLevel.map(topic => {
        topicIds.push(topic.id);
      });
      setSelectedTopics(
        [...selectedTopics, topicIds].reduce((acc, val) => acc.concat(val), [])
      );
    } else {
      var result = 0;
      selectedLevel.forEach(function (item) {
        if (selectedTopics.includes(item.id)) {
          result++;
        }
      });
      if (result === selectedLevel.length) {
        setSelectedTopics(
          selectedTopics.filter(function (element) {
            return (
              selectedLevel
                .reduce((acc, topic) => {
                  return [...acc, topic.id];
                }, [])
                .indexOf(element) === -1
            );
          })
        );
      } else {
      }
    }
  }, [selectAll]);

  useEffect(() => {
    if (selectedLevel != undefined) {
      var result = 0;
      selectedLevel.forEach(function (item) {
        if (selectedTopics.includes(item.id)) {
          result++;
        }
      });
      if (result === selectedLevel.length) {
        setSelectAll(true);
      } else {
        setSelectAll(false);
      }
    }
  }, [selectedLevel]);


  // once topics have loaded, default to the first level
  useEffect(() => {
    if (topics !== undefined && myRating != undefined) {
      //add extra topics to level 1 if additions
      console.log("rating = " + myRating);
      if (myRating == 1) {
        onLevelSelect(1);
      }
      else if (myRating > 1) {
        onLevelSelect(myRating);
      }
    }
  }, [topics]);

  const gameComponent = () => {
    switch (game.service_key) {
      case "timetables":
        return (
          <MultiplyDivide
            neveragain={props.neveragain}
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topicKeys={selectedTopicsKeys}
            topics={selectedTopics}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            gameData={game}
            timelimit={timeLimit}
            minimum={questionLimit}
          /*gameCalculations={Object.entries(topics).reduce(
              (acc, [level, topicArr]) => {
                  return [
                      ...acc,
                      ...topicArr.filter(topic => {
                          return selectedTopics.indexOf(topic.id) > -1;
                      })
                  ];
              },
              []
          )}*/
          />
        );
      case "spelling":
      console.log("assessment type" + props.assessment_type);
      if (props.assessment_type == "wordonce"){
        return (
            <Spelling
              neveragain={props.neveragain}
              homework_id={props.homework_id}
              onBack={() => endGame()}
              gameType={game.game_type}
              topics={selectedTopics}
              gameBackground={game.practice_background}
              level={selectedLevelID}
              gameData={game}
              customlist={props.customlist}
              timelimit={999999999}
              minimum={questionLimit}
              assessment_type={props.assessment_type}
            />
          );
      }else{
        return (
            <Spelling
              neveragain={props.neveragain}
              homework_id={props.homework_id}
              onBack={() => endGame()}
              gameType={game.game_type}
              topics={selectedTopics}
              gameBackground={game.practice_background}
              level={selectedLevelID}
              gameData={game}
              customlist={props.customlist}
              timelimit={timeLimit}
              minimum={questionLimit}
              assessment_type={props.assessment_type}
            />
          );
      }
        
      case "addition":
        return (
          <Addition
            neveragain={props.neveragain}
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topics={selectedTopics}
            topicKeys={selectedTopicsKeys}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            gameData={game}
            gameCalculations={Object.entries(topics).reduce(
              (acc, [level, topicArr]) => {
                return [
                  ...acc,
                  ...topicArr.filter(topic => { return selectedTopics.indexOf(topic.id) > -1; })
                ];
              }, []
            )}
            timelimit={timeLimit}
            minimum={questionLimit}
          />
        );
      case "fractions":
        return (
          <Fractions
            neveragain={props.neveragain}
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topics={selectedTopics}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            topicKeys={selectedTopicsKeys}
            gameData={game}
            gameCalculations={Object.entries(topics).reduce(
              (acc, [level, topicArr]) => {
                return [
                  ...acc,
                  ...topicArr.filter(topic => { return selectedTopics.indexOf(topic.id) > -1; })
                ];
              },
              []
            )}
            timelimit={timeLimit}
            minimum={questionLimit}
          />
        );
      case "grammar":
        return (
          <Grammar
            neveragain={props.neveragain}
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topics={selectedTopics}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            gameData={game}
            gameCalculations={Object.entries(topics).reduce(
              (acc, [level, topicArr]) => {
                return [
                  ...acc,
                  ...topicArr.filter(topic => { return selectedTopics.indexOf(topic.id) > -1; })
                ];
              }, []
            )}
            timelimit={timeLimit}
            minimum={questionLimit}
          />
        );
      case "geometry":
        return (
          <Geometry
            neveragain={props.neveragain}
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topics={selectedTopics}
            topicKeys={selectedTopicsKeys}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            gameData={game}
            gameCalculations={Object.entries(topics).reduce(
              (acc, [level, topicArr]) => {
                return [
                  ...acc,
                  ...topicArr.filter(topic => { return selectedTopics.indexOf(topic.id) > -1; })
                ];
              }, []
            )}
            timelimit={timeLimit}
            minimum={questionLimit}
          />
        );
      case "measurement":
        return (
          <Measurements
            neveragain={props.neveragain}
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topics={selectedTopics}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            topicKeys={selectedTopicsKeys}
            gameData={game}
            gameCalculations={Object.entries(topics).reduce(
              (acc, [level, topicArr]) => {
                return [
                  ...acc,
                  ...topicArr.filter(topic => { return selectedTopics.indexOf(topic.id) > -1; })
                ];
              }, []
            )}
            timelimit={timeLimit}
            minimum={questionLimit}
          />
        );
      case "numplace":
        return (
          <PlaceValue
            neveragain={props.neveragain}
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topics={selectedTopics}
            topicKeys={selectedTopicsKeys}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            gameData={game}
            gameCalculations={Object.entries(topics).reduce(
              (acc, [level, topicArr]) => {
                return [
                  ...acc,
                  ...topicArr.filter(topic => { return selectedTopics.indexOf(topic.id) > -1; })
                ];
              }, []
            )}
            timelimit={timeLimit}
            minimum={questionLimit}
          />
        );
      case "statistics":
        return (
          <Statistics
            neveragain={props.neveragain}
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topics={selectedTopics}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            gameData={game}
            gameCalculations={Object.entries(topics).reduce(
              (acc, [level, topicArr]) => {
                return [
                  ...acc,
                  ...topicArr.filter(topic => { return selectedTopics.indexOf(topic.id) > -1; })
                ];
              }, []
            )}
            timelimit={timeLimit}
            minimum={questionLimit}
          />
        );
      case "romannumerals":
        return (
          <Numerals
            neveragain={props.neveragain}
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topics={selectedTopics}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            gameData={game}
            gameCalculations={Object.entries(topics).reduce(
              (acc, [level, topicArr]) => {
                return [
                  ...acc,
                  ...topicArr.filter(topic => { return selectedTopics.indexOf(topic.id) > -1; })
                ];
              }, []
            )}
            timelimit={timeLimit}
            minimum={questionLimit}
          />
        );
      case "algebra":
        return (
          <Algebra
            neveragain={props.neveragain}
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topics={selectedTopics}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            gameData={game}
            gameCalculations={Object.entries(topics).reduce(
              (acc, [level, topicArr]) => {
                return [
                  ...acc,
                  ...topicArr.filter(topic => {
                    return selectedTopics.indexOf(topic.id) > -1;
                  })
                ];
              },
              []
            )}
            timelimit={timeLimit}
            minimum={questionLimit}
          />
        );
      case "phonics":
        return (
          <Phonics
            neveragain={props.neveragain}
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topics={selectedTopics}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            gameData={game}
            gameCalculations={Object.entries(topics).reduce(
              (acc, [level, topicArr]) => {
                return [
                  ...acc,
                  ...topicArr.filter(topic => {
                    return selectedTopics.indexOf(topic.id) > -1;
                  })
                ];
              },
              []
            )}
            timelimit={timeLimit}
            minimum={questionLimit}
          />
        );
      case "numbersense":
        return (
          <Numbersense
            neveragain={props.neveragain}
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topics={selectedTopics}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            gameData={game}
            gameCalculations={Object.entries(topics).reduce(
              (acc, [level, topicArr]) => {
                return [
                  ...acc,
                  ...topicArr.filter(topic => {
                    return selectedTopics.indexOf(topic.id) > -1;
                  })
                ];
              },
              []
            )}
            timelimit={timeLimit}
            minimum={questionLimit}
          />
        );
      case "ratioprop":
        return (
          <Ratios
            neveragain={props.neveragain}
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topics={selectedTopics}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            gameData={game}
            gameCalculations={Object.entries(topics).reduce(
              (acc, [level, topicArr]) => {
                return [
                  ...acc,
                  ...topicArr.filter(topic => {
                    return selectedTopics.indexOf(topic.id) > -1;
                  })
                ];
              },
              []
            )}
            timelimit={timeLimit}
            minimum={questionLimit}
          />
        );
      case "mvocab":
        return (
          <MathsVocab
            neveragain={props.neveragain}
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topics={selectedTopics}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            gameData={game}
            gameCalculations={Object.entries(topics).reduce(
              (acc, [level, topicArr]) => {
                return [
                  ...acc,
                  ...topicArr.filter(topic => {
                    return selectedTopics.indexOf(topic.id) > -1;
                  })
                ];
              },
              []
            )}
            timelimit={timeLimit}
            minimum={questionLimit}
          />
        );
      default:
        return null;
    }
  }
  return (
    <>
      {gameStatus && topics ? (
        gameComponent()
      ) : (
        <TopicsContainer lv={selectedLevel}>
          {selectedLevel != undefined ? (

            <Scale scaleTo={1720}>
              <div>
                <GameSelectionContainer>
                  <h1>Select Topics to Practise</h1>

                  {selectedLevel.length > 0 &&
                    selectedLevel.map(topic => {
                      return (
                        <Checkbox
                          label={topic.topicname}
                          onChange={e => {
                            if (e.target.checked === true) {
                              onTopicsSelect(topic.id);
                            } else {
                              onTopicsUnselect(topic.id);
                            }
                          }}
                          checked={
                            selectedTopics.findIndex(x => x === topic.id) !== -1
                              ? true
                              : false
                          }
                        />
                      );
                    })}
                  {selectedLevel.length == 0 &&
                    <h1 style={{ color: "red" }}>Please select a level</h1>}
                </GameSelectionContainer>
                <div>
                  {selectedTopics.length > 0 ? (
                    <GreenButton
                      style={{ width: "20%" }}
                      onClick={() => launchGame()}
                    >
                      Play
                    </GreenButton>
                  ) : (
                    <GreyedButton data-tip="You need to add a topic to practice" style={{ width: "20%" }}>Play</GreyedButton>
                  )}
                  <LevelListContainer style={{ marginBottom: "50px" }}>
                    {topics !== undefined &&
                      (levels &&
                        levels.map(level => {
                          // 1. If myRating is -1 or undefined, only Level 1 is playable
                          const noRating = myRating === -1 || myRating === undefined;

                          // 2. Define the "Playable" range: 
                          // If no rating: only level 1.
                          // If rated: Level Below, Current, or Level Above.
                          const isPlayable = noRating
                            ? level === 1
                            : (level === myRating || level === myRating - 1 || level === myRating + 1);

                          if (isPlayable) {
                            return (
                              <LevelButton
                                key={level}
                                style={{ marginTop: "5px" }}
                                onClick={() => onLevelSelect(level)}
                                active={level === selectedLevelID}
                              >
                                <div>
                                  <h4>Level {level}</h4>
                                </div>
                              </LevelButton>
                            );
                          } else {
                            return (
                              <LevelButton
                                key={level}
                                data-tip="Level Locked"
                                style={{
                                  marginTop: "5px",
                                  background: "grey",
                                  border: "2px solid #a0a0a0",
                                  cursor: "not-allowed"
                                }}
                              >
                                <div>
                                  <h4>Level {level}</h4>
                                </div>
                              </LevelButton>
                            );
                          }
                        }))}
                    <Tools className='extra' />
                  </LevelListContainer>
                </div>
              </div>
            </Scale>
          ) : (
            <div>
            </div>
          )}

          <Buttonz onClick={() => { navigate(".") }}>Back</Buttonz>
        </TopicsContainer>
      )}
    </>
  );
}

const Buttonz = styled.button`
  background: rgb(234, 146, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 146, 19, 1) 0%,
    rgba(255, 186, 32, 1) 100%
  );
  width: 20%;
  border: 2px solid #e88f12;
  color: #fff;
  user-select: none;
  padding: 0.5em;
  margin: -0.5em 0;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`

const Tools = styled(ReactTooltip)`
  font-size: 20px !important;
  background-color: #543171FF !important;
  `

const LevelButton = styled(Button)`
    text-align: center;
    width: 10%;
    height: 70px;
    margin: 5px;
    color: #fff;
    user-select: none;
    background: ${props => (props.active ? "#673b8b," : "rgb(234, 146, 19)")};
    background: ${props =>
    props.active
      ? "linear-gradient(0deg, #673b8b, #683d8c)"
      : "linear-gradient(0deg,rgba(234, 146, 19, 1) 0%,rgba(255, 186, 32, 1) 100%)"};
    border: 2px solid ${props => (props.active ? "#673b8b" : "#e88f12")};

    padding: 0.5em;
    box-sizing: border-box;
    border-radius: 0.25em;
    font-size: 3em;
    cursor: ${props => (props.active ? "pointer" : "")};
    @media (min-width: 1025px) and (max-width: 1440px) {
        font-size: 2.5em;
    }

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        margin-bottom: 0;
    }
`;
